import Button, {ButtonVariant} from 'bitmovin-web-ui/src/components/core/button';
import FloatingLabelInput from 'bitmovin-web-ui/src/components/dataEntry/input/floatingLabelInput';
import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import {pxToEm} from '../../components/globalStyles';
import {AuthenticationStatus} from '../../logic/store/authenticationStore';

//#region Styled Components

const StyledWrapperDiv = styled.div`
  width: ${pxToEm(510)}em;
  max-width: calc(100% - ${pxToEm(32)}em);
  box-sizing: border-box;
  flex-shrink: 0;
  padding: ${pxToEm(33)}em ${pxToEm(30)}em ${pxToEm(28)}em ${pxToEm(30)}em;
  background-color: white;
  border-radius: ${baseVariables.sizes.borderRadius};
  border-bottom: ${pxToEm(2)}em solid ${baseVariables.colors.orange};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-shadow: 0 ${pxToEm(50)}em ${pxToEm(40)}em ${pxToEm(-20)}em rgba(0, 0, 0, 0.15);
`;

const StyledForm = styled.form`
  text-align: center;
`;

const normalLoginTitleFontSizePx = 22;
const StyledHeadlineDiv = styled.div`
  font-size: ${pxToEm(normalLoginTitleFontSizePx)}em;
  text-align: center;
  font-weight: bold;
  margin-top: ${pxToEm(49) / pxToEm(normalLoginTitleFontSizePx)}em;
  margin-bottom: ${pxToEm(38) / pxToEm(normalLoginTitleFontSizePx)}em;
  color: ${baseVariables.colors.midnight};
`;

const StyledActionsDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: ${pxToEm(55)}em;
`;

//#endregion

interface Props {
  authStatus: AuthenticationStatus;
  onSubmit: (username, password) => void;
}

interface State {
  username: string;
  password: string;
}

class LoginForm extends React.Component<Props, State> {
  public state: Readonly<State> = {
    username: '',
    password: ''
  };

  private handleUsernameChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({username: e.currentTarget.value});
  };

  private handlePasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({password: e.currentTarget.value});
  };

  private handleSubmit = e => {
    e.preventDefault();
    this.props.onSubmit(this.state.username, this.state.password);
  };

  public render() {
    const {authStatus} = this.props;
    const hasError = authStatus === AuthenticationStatus.Error;
    const loginDisabled = authStatus === AuthenticationStatus.LoggingIn || authStatus === AuthenticationStatus.LoggedIn;

    return (
      <StyledWrapperDiv>
        <StyledForm onSubmit={this.handleSubmit}>
          <StyledHeadlineDiv>Log in using your credentials</StyledHeadlineDiv>
          <FloatingLabelInput
            autoFocus={true}
            type="email"
            label="Email"
            placeholder="john@doe.com"
            value={this.state.username}
            onChange={this.handleUsernameChange}
            onKeyPress={this.handleUsernameChange}
            hasError={hasError}
          />
          <FloatingLabelInput
            type="password"
            label="Password"
            placeholder="Password"
            value={this.state.password}
            onChange={this.handlePasswordChange}
            onKeyPress={this.handlePasswordChange}
            hasError={hasError}
          />
          <StyledActionsDiv>
            <Button type="submit" variant={ButtonVariant.FilledBlue} disabled={loginDisabled}>
              Log In
            </Button>
          </StyledActionsDiv>
        </StyledForm>
      </StyledWrapperDiv>
    );
  }
}

export default LoginForm;
